var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5126 2.79126C22.8762 2.59291 23.0102 2.13733 22.8118 1.77369C22.6135 1.41006 22.1579 1.27606 21.7943 1.47441C20.8534 1.98763 19.9584 2.56983 19.1155 3.21412C18.7707 3.07594 18.3943 2.99992 18.0001 2.99992H6.00014C4.34329 2.99992 3.00014 4.34306 3.00014 5.99992V17.9999C3.00014 19.6567 4.34329 20.9999 6.00015 20.9999H18.0001C19.657 20.9999 21.0001 19.6567 21.0001 17.9999V5.99992C21.0001 5.30342 20.7628 4.66236 20.3646 4.1532C21.0468 3.65486 21.764 3.19954 22.5126 2.79126ZM20.3646 4.1532C17.5086 6.23916 15.2648 9.0787 13.8989 12.3759L12.6969 15.2774C12.6426 15.414 12.5477 15.5361 12.4162 15.6238C12.0715 15.8535 11.6059 15.7604 11.3761 15.4158C10.1108 13.5178 8.48212 11.8891 6.58412 10.6238C6.23947 10.394 6.14634 9.9284 6.37611 9.58375C6.60587 9.23911 7.07152 9.14597 7.41617 9.37574C9.09768 10.4967 10.5847 11.8801 11.8218 13.4705L12.5131 11.8018C13.9263 8.39051 16.2116 5.43384 19.1155 3.21412C19.6108 3.41259 20.0408 3.73931 20.3646 4.1532Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxAlt);
export default __webpack_public_path__ + "static/media/check-box-alt.5fe80ab9a81dd11fc769fc010bf3872d.svg";
export { ForwardRef as ReactComponent };